import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-lg font-bold mb-4">About</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/editorial-policy" className="text-gray-300 hover:text-white transition cursor-pointer">
                  Editorial Policy
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Plan Your Trip */}
          <div>
            <h3 className="text-lg font-bold mb-4">Plan Your Trip</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/antigua-guatemala-2-week-itinerary" className="text-gray-300 hover:text-white transition cursor-pointer">
                  2 Weeks Itinerary
                </Link>
              </li>
              <li>
                <Link to="/antigua-guatemala-3-day-itinerary" className="text-gray-300 hover:text-white transition cursor-pointer">
                  3-Day Itinerary
                </Link>
              </li>
              <li>
                <Link
                  to="/plan-my-antigua-trip"
                  className="text-gray-300 hover:text-white transition cursor-pointer"
                >
                  Plan My Trip
                </Link>
              </li>
              <li>
                <Link
                  to="/antigua-guatemala-budget-guide"
                  className="text-gray-300 hover:text-white transition cursor-pointer"
                >
                  Budget Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/best-time-to-visit-antigua-guatemala"
                  className="text-gray-300 hover:text-white transition cursor-pointer"
                >
                  Best Time to Visit
                </Link>
              </li>
            </ul>
          </div>

          {/* Popular Guides */}
          <div>
            <h3 className="text-lg font-bold mb-4">Popular Guides</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/acatenango-hike-from-antigua" className="text-gray-300 hover:text-white transition cursor-pointer">
                  Acatenango Hike
                </Link>
              </li>
              <li>
                <Link to="/guatemala-city-airport-to-antigua" className="text-gray-300 hover:text-white transition cursor-pointer">
                  Airport Transfer
                </Link>
              </li>
              <li>
                <Link to="/is-antigua-guatemala-safe" className="text-gray-300 hover:text-white transition cursor-pointer">
                  Safety Guide
                </Link>
              </li>
              <li>
                <Link to="/best-hotels-in-antigua-guatemala" className="text-gray-300 hover:text-white transition cursor-pointer">
                  Best Hotels
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-bold mb-4">Stay Updated</h3>
            <p className="text-sm text-gray-300 mb-4">Get the latest Antigua travel tips and guides delivered to your inbox.</p>
            <Link to="/antigua-guatemala-3-day-itinerary" className="inline-block bg-teal-500 hover:bg-teal-600 text-white px-4 py-2 rounded-lg text-sm font-semibold transition whitespace-nowrap cursor-pointer">
              Get Free Itinerary
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <p>© {new Date().getFullYear()} La Antigua Guatemala. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <Link to="/privacy-policy" className="hover:text-white transition cursor-pointer">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition cursor-pointer">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}